export default "__VITE_ASSET__C5Bwmx70__"